import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { Currency } from '@/components/atoms/Currency'
import { WalletHero } from '@/components/atoms/WalletHero'
import { StakeButton } from '@/components/molecules/StakeButton'

import { Routes } from '@/router/routes'
import { toTokenCentsString } from '@/utils/token'
import { isNative } from '@/utils/utils'

import { DepositButton } from '../DepositButton'
import { StakingVaultButton } from '../StakingVaultButton'
import { WithdrawButton } from '../WithdrawButton'

interface TransactionHistoryHeaderProps {
  balance?: string
  stakedBalance?: string
}

export const TransactionHistoryHeader: FC<TransactionHistoryHeaderProps> = ({
  balance = '0',
  stakedBalance = '0',
}: TransactionHistoryHeaderProps) => {
  const { t } = useTranslation('common')
  const history = useHistory()

  const handleBannerClick = useCallback(() => {
    stakedBalance
      ? history.push(Routes.STAKE_VAULT)
      : history.push(Routes.STAKE)
  }, [history, stakedBalance])

  return (
    <div className="p-4">
      <WalletHero
        handleOnClick={handleBannerClick}
        title={t('wallet.yourBalance')}
        footer={
          !isNative() && <StakingVaultButton stakedAmount={stakedBalance} />
        }
      >
        <div className="flex flex-col pb-2">
          <span
            className="text-[8vw] sm:text-[3rem] font-bold"
            title={toTokenCentsString(balance)}
          >
            <Currency value={balance} isHighlighted />
          </span>
        </div>
        {!isNative() && (
          <div className="flex flex-start flex-wrap gap-x-1 xs:gap-x-2 gap-y-2">
            <StakeButton text={t('wallet.stake.stake')} />
            <DepositButton />
            <WithdrawButton />
          </div>
        )}
      </WalletHero>
    </div>
  )
}
